import {
  MDBAlert,
  MDBBtn,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getAllTheLocationsInfo, getExisting911Locations, getExistingUserLocations, getGlobalLocationList, setGlobalLocationFilter } from "../../apiclients/streamsapi_bridge";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import PopupLoader from "../popups/PopupLoader";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import AddNineOneOneLocation from "../popups/locations/Add911Location";
import AddLocations from "../popups/locations/AddLocations";
import Remove911Locations from "../popups/locations/Remove911Location";
import RemoveLocations from "../popups/locations/RemoveLocation";
import { formattedNumber } from "../popups/phonenumbers/AddRemoveNumbers";
import DeleteLocationFilter from "../popups/users/DeleteLocationFilter";
import LocationMap from "../popups/locations/LocationMap";
import AllLocations from "../AllLocations";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import { isFiveNineAccount } from "../Login";
function LocLandingPage(props) {
  const location = useLocation();
  const actTab = location.state ? location.state.tab ? location.state.tab : "location" : "location";
  const actTab1 = location.state ? location.state.tab1 ? location.state.tab1 : "tab1" : "tab1";
  const [acdActive, setAcdActive] = useState(actTab);
  // const [acdActive, setAcdActive] = useState("location");
  const [fillActive, setFillActive] = useState("tab1");
  const [removeLocation, setRemoveLocation] = useState(false);
  const [usersLocations, setUsersLocations] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const toggleRemoveLocation = () => setRemoveLocation(!removeLocation);
  const [removeLocationId, setRemoveLocationId] = useState('');
  const [removeLocationInfo, setRemoveLocationInfo] = useState();
  const [addLocations, setAddLocations] = useState();
  const toggleAddLocation = () => setAddLocations(!addLocations);
  const [nineOneOnelocationList, setNineOneOneLocationList] = useState([]);
  const [allLocationsInfo, setallLocationsInfo] = useState([]);
  const [allLocationsInfoTemp, setallLocationsInfoTemp] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [rerender, setReRender] = useState(false);
  const [remove911Location, setRemove911Location] = useState(false);
  const toggleRemove911Location = () => setRemove911Location(!remove911Location);
  const [remove911LocationInfo, setRemove911LocationInfo] = useState();
  const [LocationSelected, setLocationSelected] = useState("");
  const [LocationSelectedIds, setLocationSelectedIds] = useState([]);
  const [newLocationSelectedIds, setNewLocationSelectedIds] = useState([]);
  const [existLocationSelectIds, setexistLocationSelectIds] = useState([]);
  const [existNewLocationSelectIds, setexistNewLocationSelectIds] = useState([]);
  const [filterLocationList, setfilterLocationList] = useState([]);
  const [displayFilterLocations, setdisplayFilterLocations] = useState([]);
  const [displayNewFilterLocations, setdisplayNewFilterLocations] = useState([]);
  const [filterReRender, setFilterReRender] = useState(true);
  const [searchMainValue, setsearchMainValue] = useState("");
  const [searchEditValue, setsearchEditValue] = useState("");
  const [deleteFilter, setdeleteFilter] = useState(false);
  const deleteFilterToggle = () => setdeleteFilter(!deleteFilter);
  const [allLocation, setallLocation] = useState(false);
  const [allNewLocation, setallNewLocation] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [basicActive, setBasicActive] = useState(actTab1);
  const [locationNames, setLocationNames] = useState([]);

  const [searchValue, setsearchValue] = useState("");
  const [searchValueOff, setsearchValueOff] = useState("");
  const [filteredninooRows, setFilteredninooRows] = useState([]);
  const [isFiveNineAcc, setisFiveNineAcc] = useState(false)
  const [filteredOffRows, setFilteredOffRows] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [tab2SearchAutoFocus, setTab2SearchAutoFocus] = useState(false); // seperate state for office tab2
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [locOffList, setlocOffList] = useState([]);
  const [loc911List, setloc911List] = useState([]);
  const searchRef = useRef(null);
 const searchInputRef = useRef(null);
  useEffect(() => {
    if (tab2SearchAutoFocus && basicActive === 'tab2') {
      setTimeout(() => {
        searchInputRef.current?.focus();
        setTab2SearchAutoFocus(false);
      }, 200);
    }
  }, [tab2SearchAutoFocus,basicActive]);

  useEffect(() => {
    console.log("Received locationList:", locationList);
    if (locationList && locationList.length > 0) {
      const uniqueNames = [...new Set(locationList.map((location) => location.name))];
      setLocationNames(uniqueNames);
    }
  }, [locationList]);
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,basicActive)
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };
  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage(""); // Clear the error message in the parent component
      }, 5000);
    }
  }, [errorMessage]);
  function showThisInf(evntData) {
    console.log("evntData ::::::::: " + JSON.stringify(evntData));
    const currentIndex = locOffList.findIndex((tmdata) => tmdata.location_id == evntData.locDetails.location_id);
    const previousLoc = currentIndex > 0 ? locOffList[currentIndex - 1] : null;
    const nextLoc = currentIndex < locOffList.length - 1 ? locOffList[currentIndex + 1] : null;
    const currentLoc = evntData.locDetails;
    const combinedData = {
      currentLoc,
      previousLoc,
      nextLoc,
      locationList: locOffList
    };
    navigate("/locDetails", {
      state: combinedData,
    });

  }
  const handleAcdClick = (value) => {
    console.log("value " + value)
    if (value == "911location") {
      setAcdActive(null);
      setTimeout(() => { setAcdActive(value) }, 0);
    }
    if (value === acdActive) {
      return;
    }
    setAcdActive(value);
  };

  const [agent, setAgent] = useState("tab1");

  const advancedData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Address", field: "Address", sort: true },
      { label: "911 Verified", field: "Verified", sort: false },
      { label: "Primary Contact", field: "contact", sort: true },
      { label: "Primary Number", field: "number", sort: true },
      { label: "Users", field: "user", sort: true },
      { label: "Devices", field: "Devices", sort: true },
      { label: "Remove", field: "Delete", sort: false },
    ],
    rows: filteredOffRows
  };



  function showThis911Inf(evntData) {
    console.log("911 evntData ::::::::: " + JSON.stringify(evntData));
    const currentIndex = loc911List.findIndex((tmdata) => tmdata.nineoo_loc_id == evntData.nineOOLocDetails.nineoo_loc_id);
    const previousLoc = currentIndex > 0 ? loc911List[currentIndex - 1] : null;
    const nextLoc = currentIndex < loc911List.length - 1 ? loc911List[currentIndex + 1] : null;
    const currentLoc = evntData.nineOOLocDetails;
    const combinedData = {
      currentLoc,
      previousLoc,
      nextLoc,
      locationList: loc911List
    };
    navigate("/location911settings", {
      state: combinedData,
    });
  }

  const handleDeleteUserLocation = (evntData, info) => {
    evntData.preventDefault();
    evntData.stopPropagation();
    console.log("IN handleDeleteUserLocation info Delete :" + JSON.stringify(info));
    toggleRemoveLocation();
    setRemoveLocationInfo(info);
  }

  const handleDeleteUser911Location = (evntData, info) => {
    evntData.preventDefault();
    evntData.stopPropagation();
    console.log("IN handleDeleteUser911Location info Delete :" + JSON.stringify(info));
    toggleRemove911Location();
    setRemove911LocationInfo(info);
  }

  useEffect(() => {
    const fetchExistingLocations = async () => {
      try {
        sessionStorage.setItem("current_link", "loclanding");
        console.log("[fetchExistingLocations] ");
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        //let groupid = 1;
        setIsloading(true);
        let serverResponse = await getExistingUserLocations(siteid);
        setIsloading(false);

        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error('Network response was not ok');
        } else {
          let responseData = await serverResponse.json()
          let apiData = responseData.locations;
          console.log("Locations List:::: " + JSON.stringify(apiData));
          let data = [];
          setlocOffList(apiData);
          apiData.forEach(element => {
            var json = {};
            json.locDetails = element;
            json.default_loc = element.default_loc;
            json.actualName = element.location_name;
            json.name = element.location_name
            // json.name = <div className="d-flex align-items-center">{element.location_name}
            //   {element.default_loc && (
            //     <>
            //       <div className="px-2 ms-2 border border-1 rounded-pill border-success">
            //         <span className="small text-success">Default</span>
            //       </div>
            //     </>
            //   )}
            // </div>

            json.Address = element.address;
            json.Verified = element.noo_verified ? <MDBIcon fas icon="check" className="ms-4 ps-1 primary checked-icon" /> : <h6 class="no-red ms-4">No</h6>;
            json.contact = element.pri_contact;
            let phNumber = element.pri_num ? formattedNumber(element.pri_num) + "" : ""
            json.actualNumber = phNumber?.toString().replace(/[ ]/g, '');
            json.number = phNumber;
            json.phoneNum = element.pri_num + "" ?? "";
            json.user = element.users ?? '-';
            json.Devices = element.ip_phones_devices ?? '-';
            json.Delete = !element.default_loc ?
              <>
                <div className="d-flex align-items-center justify-content-center">
                  <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(event) => handleDeleteUserLocation(event, element)}>
                    <i className="fas fa-xmark text-primary fs-5 mx-2 "></i>
                  </div>
                </div>
              </>
              : "";
            json.location_id = element.location_id;
            data.push(json);
          });
          setLocationList(data);
          setFilteredOffRows(data);
          setUsersLocations(apiData);
          // setDataLoaded(true)
         setTab2SearchAutoFocus(true);
        }
      } catch (e) {
        console.log("[BlfUsers.js][fetchExistingUsers] : " + e);
      }
    }
    if (basicActive === 'tab2') {
      fetchExistingLocations();
    }
  }, [basicActive]);

  const navigate = useNavigate();
  function LocSettings(props) {
    navigate("/locDetails")

  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);


  useEffect(() => {
    const fetchExisting911Locations = async () => {
      try {
        console.log("[fetchExisting911Locations] ");
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        setIsloading(true);
        let serverResponse = await getExisting911Locations(siteid);
        setIsloading(false);

        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error('Network response was not ok');
        } else {
          let responseData = await serverResponse.json()
          let apiData = responseData.nineoolocations;
          console.log("911 Locations List:::: " + JSON.stringify(apiData));
          let data = [];
          setloc911List([...apiData].sort((a, b) =>
            a.nineoo_loc_name.localeCompare(b.nineoo_loc_name)
          ));
          apiData.forEach(element => {
            var json = {};
            json.nineOOLocDetails = element;
            json.name = element.nineoo_loc_name;
            json.Address = element.loc_address;
            json.contact = element.loc_primary_contact;
            let phNumber = formattedNumber(element.loc_primary_number) + "";
            json.actualNumber = phNumber?.toString().replace(/[ ]/g, '');
            json.number = phNumber;
            json.phoneNum = element.loc_primary_number + "" ?? ""
            json.Devices = element.loc_ipdevices;
            json.location_id = element.nineoo_loc_id;
            json.Delete =
              <>
                <div className="d-flex align-items-center justify-content-start">
                  <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(event) => handleDeleteUser911Location(event, element)}>
                    <i className="fas fa-xmark text-primary fs-5 mx-2 "></i>
                  </div>
                </div>
              </>


            data.push(json);
          });
          setNineOneOneLocationList(data);
          setFilteredninooRows(data);
          setDataLoaded(true)
        }
      } catch (e) {
        console.log("[BlfUsers.js][fetchExistingUsers] : " + e);
      }
    }
    if (basicActive === 'tab3' || rerender) {
      fetchExisting911Locations();
      setReRender(false);
    }

  }, [rerender, basicActive]);




  const basic911Data = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Address", field: "Address", sort: true },
      { label: "Primary Contact", field: "contact", sort: true },
      { label: "Primary Number", field: "number", sort: true },
      { label: "Devices", field: "Devices", sort: true },
      { label: "Remove", field: "Delete", sort: false },
    ],
    rows: filteredninooRows
  };
  const [AddACDQueue, setAddACDQueue] = useState(false);
  const toggleShow9 = () => setAddACDQueue(!AddACDQueue);
  const [Add911Location, setAdd911Location] = useState(location.state ? location.state.open911add : false);
  const toggleShow25 = () => setAdd911Location(!Add911Location);
  const [basicModal, setBasicModal] = useState(location.state ? location.state.openadd : false);
  const toggleOpen = () => setBasicModal(!basicModal);

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [addFilter, setAddFilter] = useState(false);
  const [showSeatPlan, setShowSeatPlan] = useState(false);
  const [showRole, setShowRole] = useState(false);
  const addLocationRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);


  function handleClick() {
    addLocationRef.current.click();
  }

  const toggleFilter = () => {
    setAddFilter(!addFilter)
    setShowRole(false); // Ensure other div is hidden
    setShowSeatPlan(false); // Ensure other div is hidden
  };
  const toggleSeatPlan = () => {
    setShowSeatPlan(!showSeatPlan);
    setShowRole(false); // Ensure other div is hidden
  };

  const toggleRole = () => {
    setShowRole(!showRole);
    setShowSeatPlan(false); // Ensure other div is hidden
  };

  const toggleBackClick = () => {
    setShowRole(false); // Ensure other div is hidden
    setShowSeatPlan(false); // Ensure other div is hidden
  }


  const defaultData = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];

  const [data, setData] = useState(defaultData);

  const onSearch = (value) =>
    setData(defaultData.filter((item) => item.toLowerCase().startsWith(value.toLowerCase())));

  useEffect(() => {
    if (filterReRender) {
      // const userLocationFilter = sessionStorage.getItem("userLocationFilter") ?
      //   JSON.parse(sessionStorage.getItem("userLocationFilter")) :
      //   [];
      // const glocationChanged = sessionStorage.getItem("global_location_changed");

      // if (userLocationFilter && userLocationFilter.length > 0 && !glocationChanged) {
      //   setTheStateValues(userLocationFilter);
      // } else {
      //   sessionStorage.removeItem('global_location_changed');
      getUserLocationFilter();
      // }
      setFilterReRender(false);
    }
  }, [filterReRender]);


  async function getUserLocationFilter() {
    try {
      const adminSession = sessionStorage.getItem("admin_session");
      const siteid = JSON.parse(adminSession).siteid;
      let response;
      const extracondition = `?module_type=3`;
      response = await getGlobalLocationList(siteid, extracondition);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      let rawData = await response.json();
      console.log(" Global user Location filter ::::::::: : " + JSON.stringify(rawData));
      if (!rawData) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      const userLocationsFilter = rawData?.result ?? [];
      setTheStateValues(userLocationsFilter);
      // sessionStorage.setItem("userLocationFilter", JSON.stringify(userLocationsFilter));
      const uniqueNames = [...new Set(userLocationsFilter?.map(location => location.entity_name))];
      console.log("Extracted Location Names:", uniqueNames);
      setLocationNames(uniqueNames);
    } catch (error) {

    }

  }

  function setTheStateValues(userLocationsFilter) {
    let LocationSelected = userLocationsFilter.filter(userLocation => userLocation.selected).map(userLocation => userLocation.entity_name).join(', ');
    const LocationSelectedids = userLocationsFilter.some(location => location.entity_id === -1 && location.selected)
      ? userLocationsFilter.map(location => location.entity_id)
      : userLocationsFilter.filter(location => location.selected).map(location => location.entity_id);
    const index = LocationSelectedids.findIndex(id => id === -1);
    if (index !== -1) {
      LocationSelectedids.splice(index, 1);
      LocationSelected = "";
      setNewLocationSelectedIds(LocationSelectedids);
      setexistNewLocationSelectIds(LocationSelectedids);
      // setallLocation(true);
      setallNewLocation(true);
    }

    const newuserLocationsFilter = userLocationsFilter.filter((loc) => parseInt(loc.entity_id) !== -1);
    setfilterLocationList(newuserLocationsFilter);
    setdisplayFilterLocations(newuserLocationsFilter);
    setdisplayNewFilterLocations(newuserLocationsFilter);
    if (LocationSelected && LocationSelected !== "") {
      setLocationSelected(`${t("Locations")} : ${LocationSelected}`);
      setLocationSelectedIds(LocationSelectedids);
      setexistLocationSelectIds(LocationSelectedids);

    }

  }

  function cancelfilterChanges(flag) {
    if (flag === 1) {
      setLocationSelectedIds(existLocationSelectIds);
      if (existLocationSelectIds.length === filterLocationList.length || existLocationSelectIds.length === displayFilterLocations.length) {
        setallLocation(true);
      } else {
        setallLocation(false);
      }
    } else {
      setNewLocationSelectedIds(existNewLocationSelectIds);
      if (existNewLocationSelectIds.length === filterLocationList.length || existNewLocationSelectIds.length === displayFilterLocations.length) {
        setallNewLocation(true);
      } else {
        setallNewLocation(false);
      }
    }
  }

  const handleFilterCheckboxChange = (value) => {
    const updatedValues = [...LocationSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayFilterLocations.length) {
      setallLocation(false);
    } else {
      const tempArray = displayFilterLocations.map(loc => loc.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallLocation(false);
          break;
        }
      }
      setallLocation(true);
    }
    setLocationSelectedIds(updatedValues);
  };

  const handleNewFilterCheckboxChange = (value) => {
    const updatedValues = [...newLocationSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }

    if (updatedValues.length !== displayNewFilterLocations.length) {
      setallNewLocation(false);
    } else {
      const tempArray = displayNewFilterLocations.map(loc => loc.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallNewLocation(false);
          break;
        }
      }
      setallNewLocation(true);
    }

    setNewLocationSelectedIds(updatedValues);
  };

  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  const handleSubmit = async (event, selectValue) => {
    event.preventDefault();
    let filteredValue = [...selectValue];
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    if (selectValue.length === filterLocationList.length) {
      filteredValue = [-1];

    }
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: filteredValue,
      filter_type: 1,
      filter_key: 3,
      module_type: 3,
    }
    // if (loggedinUser.indexOf("@") !== -1) {
    //   update.agentid = loggedinUser;
    // }
    console.log("Modify Location user filter value  :::: " + JSON.stringify(update));
    setIsloading(true);
    let saverep = await setGlobalLocationFilter(update);
    setIsloading(false);
    console.log(`reponse of Edit Location user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified Location user data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
      // sessionStorage.removeItem('userLocationFilter');
      navigate("/LocLanding", {
        state: { tab: "location", tab1: "tab2" },
      });
      window.location.reload();
      // window.location.href = "/LocLanding";
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
  }

  function handleSearch(e, flag) {
    const value = e.target.value
    if (flag === 1) {
      setsearchMainValue(value);
      setdisplayNewFilterLocations(customSearch(filterLocationList, value, ["entity_name"]))
    } else {
      setsearchEditValue(value);
      setdisplayNewFilterLocations(customSearch(filterLocationList, value, ["entity_name"])
      )
    }


  }

  function setDefaultValue(e) {
    e.preventDefault();
    if (LocationSelected) {
      setNewLocationSelectedIds([]);
    }
  }

  function handleAllLocation(e) {
    // e.preventDefault();
    setallLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayFilterLocations.map(loc => loc.entity_id);
      setLocationSelectedIds(locId);
    } else {
      setLocationSelectedIds([]);
    }

  }
  function handleNewAllLocation(e) {
    // e.preventDefault();
    setallNewLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterLocations.map(loc => loc.entity_id);
      setNewLocationSelectedIds(locId);
    } else {
      setNewLocationSelectedIds([]);
    }

  }

  function removeLocFilter() {
    removeThisFilter(3);

  }

  const removeallfilters = (value) => {
    removeThisFilter(-1);

  }


  async function removeThisFilter(filterKey) {
    // e.preventDefault();
    const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: [-1],
      filter_type: 1,
      filter_key: filterKey ? parseInt(filterKey) : -1,
      module_type: 3,
    }

    console.log("Modify User filter value  :::: " + JSON.stringify(update));
    let deleteFilter = await setGlobalLocationFilter(update);
    setIsloading(false);

    let deleteMsg = await deleteFilter.json();
    console.log("Response... ");
    console.log("response to remove the filter :::::::::::::; " + JSON.stringify(deleteMsg));
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      // window.location.href = "/LocLanding";
      navigate("/LocLanding", {
        state: { tab: "location", tab1: "tab2" },
      });

    } else {
      localStorage.setItem("s_message", deleteMsg.message);
      // sessionStorage.removeItem('userLocationFilter');
      // window.location.href = "/LocLanding";
      navigate("/LocLanding", {
        state: { tab: "location", tab1: "tab2" },
      });

    }
    window.location.reload();
  }



  useEffect(() => {
    setisFiveNineAcc(isFiveNineAccount())
    console.log("fivenine ::",)
    const patchTitles = () => {
      const tds = document.querySelectorAll('table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector('.usersData-Table');

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);


  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);
    const filteredUsers = customSearch(locationList, searchValue, UIConstant.OFFICE_LANDING);

    setFilteredOffRows(filteredUsers);
  };





  const handleManualSearchOne = (searchValueOff) => {
    setsearchValueOff(searchValueOff);
    const filteredUsers = customSearch(nineOneOnelocationList, searchValueOff, UIConstant.NINEONE_LANDING);

    setFilteredninooRows(filteredUsers);
  };



  return (
    <React.Fragment>
      <>
        <MainLinks active={7} />
        <Body
          tablinks={7}
          sublink={7}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header px-0 py-3">
                    <h5 className="mb-0 ">
                      {t("locations")}
                    </h5>
                  </div>
                  <div>
                    <MDBTabs className="card-body">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => {
                            setBasicActive("tab1")
                            handleAcdClick("location")
                          }
                          }
                          active={acdActive === "location"}
                        >
                          {t("locations")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("911location")}
                          active={acdActive === "911location"}
                        >
                          {t("LocationsMap")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>

                      <MDBTabsPane open={acdActive === "location"}>
                        <MDBTabs className='mb-3'>
                          <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                              All Locations
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                              Office
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            {!isFiveNineAcc && (
                              <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                911 Only
                              </MDBTabsLink>
                            )}

                          </MDBTabsItem>
                        </MDBTabs>

                        <MDBTabsContent>
                          <MDBTabsPane open={basicActive === 'tab1'}>

                            <AllLocations
                             basicActive={basicActive === 'tab1' && acdActive==='location'}
                            />


                          </MDBTabsPane>
                          <MDBTabsPane open={basicActive === 'tab2'}>



                            <div>

                              <div className="d-flex align-items-center justify-content-between actionbar  ">
                                <div>

                                  <MDBBtn
                                    className="green-button d-inline-block float-end"
                                    data-mdb-toggle="modal"
                                    data-mdb-target="#exampleModal"
                                    onClick={toggleOpen}
                                  >
                                    <MDBIcon fas icon="plus" size="sm" /> {t("addlocation")}
                                  </MDBBtn>
                                </div>
                              </div>
                              <div className="position-absolute left__341px d-flex">
                                <div className="d-flex">
                                  <div className="ms-4 popconfirmFilter">
                                    {LocationSelected && (
                                      <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                                        <MDBChip className="m-0" onClick={(e) => setDefaultValue(e)}

                                        >
                                          <div className="filterElliipse">
                                            {LocationSelected}
                                          </div>
                                          <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); removeLocFilter() }} />
                                        </MDBChip>
                                      </>}>
                                        <MDBPopconfirmMessage className="p-2">
                                          <p className='mb-2 fw-600'>
                                            {t("location")}
                                          </p>
                                          <div className="d-flex align-items-center">
                                            <div className="ms-2 w-100">
                                              <MDBInput placeholder="search" value={searchMainValue} onChange={(e) => handleSearch(e, 1)} />
                                            </div>
                                          </div>
                                          <div className="filter-border py-2"></div>
                                          <div className="mt-3 w-100">
                                            <MDBCheckbox checked={allLocation} onChange={(e) => handleAllLocation(e)} label='Select All' />
                                          </div>
                                          <div className="filtersScroll">
                                            {displayFilterLocations && displayFilterLocations.map((Location) => (
                                              <MDBCheckbox name='flexCheck' value={Location.entity_id} id={Location.entity_id} label={Location.entity_name} checked={LocationSelectedIds.includes(Location.entity_id)}
                                                onChange={() => handleFilterCheckboxChange(Location.entity_id)}
                                              />
                                            ))}
                                          </div>
                                          <div className="filter-border"></div>
                                          <div className="d-flex float-end mt-3">
                                            {(LocationSelectedIds.length > 0 && !isArraysEqual(LocationSelectedIds, existLocationSelectIds)) && (
                                              <>
                                                <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                                                <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                                                  handleSubmit(e, LocationSelectedIds);
                                                }}> Apply</MDBBtn>
                                              </>
                                            )}
                                          </div>
                                        </MDBPopconfirmMessage>
                                      </MDBPopconfirm>
                                    )}
                                  </div>
                                </div>
                                {!LocationSelected && (
                                  <div className=" ms-2">


                                    <MDBPopconfirm placement='bottom-start' onClick={(e) => { setDefaultValue(e); setIsFilterOpen(true); }} onClose={() => setIsFilterOpen(false)}  className="shadow-6" btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
                                      <MDBPopconfirmMessage className="p-2">
                                        <p className='mb-2 fw-600'>
                                          {t("location")}
                                        </p>

                                        <div className="d-flex align-items-center">
                                          <div className="ms-2 w-100 position-relative">
                                            <MDBInput  autoFocus={isFilterOpen} placeholder="search" value={searchEditValue} onChange={(e) => handleSearch(e, 2)} />
                                            {/* <MDBIcon fas icon="times" className="searchClearIcon" /> */}
                                          </div>
                                        </div>
                                        <div className="filter-border py-2"></div>

                                        <div className="mt-3 searchCheckbox-align">
                                          <MDBCheckbox checked={allNewLocation} onChange={(e) => handleNewAllLocation(e)} label='Select All' />
                                        </div>
                                        <div className="filtersScroll">
                                          {displayNewFilterLocations && displayNewFilterLocations.map((Location) => (
                                            <div className="mt-2">
                                              <MDBCheckbox name='flexCheck' value={Location.entity_id} id={Location.entity_id} label={Location.entity_name} checked={newLocationSelectedIds.includes(Location.entity_id)}
                                                onChange={() => handleNewFilterCheckboxChange(Location.entity_id)}
                                              />
                                            </div>
                                          ))}
                                        </div>
                                        <div className="filter-border"></div>
                                        <div className="d-flex float-end mt-3">
                                          {(newLocationSelectedIds.length !== 0 && newLocationSelectedIds.length !== filterLocationList.length) && (
                                            <>
                                              <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(2)}>Cancel</MDBBtn>
                                              <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                                                handleSubmit(e, newLocationSelectedIds);
                                              }}> Apply</MDBBtn>
                                            </>
                                          )}

                                        </div>
                                      </MDBPopconfirmMessage>
                                    </MDBPopconfirm>

                                  </div>
                                )}

                                {LocationSelected && (
                                  <MDBBtn className="mx-2" onClick={removeallfilters}>Clear</MDBBtn>
                                )}
                                {/* <MDBBtn
                            className="d-inline-block"
                            data-mdb-toggle="modal"
                            data-mdb-target="#exampleModal"
                          >
                            <MDBIcon fas icon="plus" size="sm" /> {t("Add Filter")}
                          </MDBBtn> */}



                              </div>
                              <div className='mb-2 mt-2 position-relative w-auto'>
                                <MDBInput ref={searchInputRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                              </div>
                              <div className="">
                                <MDBDatatable
                                  sortField="Name"
                                  className="actioncolumn office-location"
                                  key={searchValue}
                                  data={{
                                    ...advancedData,
                                    rows: filteredOffRows, // Use filtered rows here
                                  }}
                                  fixedHeader
                                  noFoundMessage="No results"
                                  entries={50}
                                  onRowClick={(event) => {
                                    showThisInf(event);
                                  }} />
                              </div>

                            </div>



                          </MDBTabsPane>
                          <MDBTabsPane open={basicActive === 'tab3'}>

                            <div className="actionbar">
                              <div className="mx-3">
                                <MDBBtn className="float-end" onClick={toggleShow25}>
                                  <MDBIcon fas icon="plus" size="sm" /> {t("Add911Location")}
                                </MDBBtn>
                              </div>
                            </div>
                            <div className='mb-2 mt-4 position-relative w-auto'>
                              <MDBInput ref={searchRef} label="Search" value={searchValueOff} onChange={(e) => handleManualSearchOne(e.target.value)} />
                              <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                            </div>
                            <div className="locDataTable">
                              <MDBDatatable
                                // search
                                fixedHeader
                                sortField="Name"
                                noFoundMessage="No results"
                                entries={50}
                                // data={basic911Data}
                                data={
                                  // {
                                  basic911Data
                                  // rows: filteredninooRows, // Use filtered rows here
                                // }
                              }
                                onRowClick={(event) => {
                                  showThis911Inf(event);
                                }} />
                            </div>

                          </MDBTabsPane>
                        </MDBTabsContent>

                      </MDBTabsPane>
                    </MDBTabsContent>
                    <MDBTabsContent>
                      {acdActive === "911location" && <MDBTabsPane open={acdActive === "911location"} > <LocationMap toggleShow25={toggleShow25} setBasicActive={setBasicActive} /></MDBTabsPane>}
                    </MDBTabsContent>
                  </div>

                </div>
              </section>
            </>
          }
        />

        {removeLocation && (
          <PopupLoader
            title={"Remove Location"}
            content={
              <RemoveLocations
                onClose={toggleRemoveLocation}
                removeLocationInfo={removeLocationInfo}
                tab={basicActive === 'tab2' ? 'tab2' : 'tab1'}  // Pass current active tab here
              />
            }
            className={""}
            onShow={setRemoveLocation}
            onClose={toggleRemoveLocation}
          />
        )
        }

        {basicModal && (
          <PopupLoaderNew
            title={"Add Location"}
            content={<AddLocations
              onClose={toggleOpen}
              ref={addLocationRef}
              setIsloading={setisLoading}
            />}
            className="modal-lg"
            onShow={setBasicModal}
            onClose={toggleOpen}
            onSave={handleClick}
            isloading={isLoading}
            flag={1}
          />
        )}

        {Add911Location && (
          <PopupLoaderNew
            title={t("Add911Loc")}
            content={<AddNineOneOneLocation
              setAcdActive={setAcdActive}
              setSuccessMessage={setSuccessMessage}
              setReRender={setReRender}
              setlocationName={null}
              removeFlag={false}
              setErrorMessage={setErrorMessage}
              onClose={toggleShow25}
              ref={addLocationRef}
              setIsloading={setisLoading}

            />}
            onShow={setAdd911Location}
            onClose={toggleShow25}
            onSave={handleClick}
            isloading={isLoading}
            flag={1}
          />
        )}
        {remove911Location && (
          <PopupLoaderNew
            title={"Remove 911 Only Location"}
            content={
              <Remove911Locations
                onClose={toggleRemove911Location}
                remove911LocationInfo={remove911LocationInfo}
                ref={addLocationRef}
                isloading={isLoading}
                setIsloading={setisLoading}
              />
            }
            className={""}
            onShow={setRemove911Location}
            onClose={toggleRemove911Location}
            onSave={handleClick}
            isloading={isLoading}
            flag={4}
          />
        )
        }
        {deleteFilter && (
          <PopupLoader
            title={"Delete Location Filter"}
            content={<DeleteLocationFilter
              locationflag={2}
              onClose={deleteFilterToggle}
            />}
            onShow={setdeleteFilter}
            onClose={deleteFilterToggle}
          />
        )}
        {successMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )}
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}

        {errorMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-times-circle me-3"></i>
            <span className="alert-msg">{errorMessage}</span>
          </MDBAlert>
        )}
        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
      </>
    </React.Fragment>
  );
}

export default LocLandingPage;
